export function extractErrorMessage(error: any, genericMessage = "Ocorreu um erro tente novamente.") {
  if (Array.isArray(error.response?.data?.message)) {
    return error.response?.data?.message[0] || genericMessage
  }

  return error.response?.data?.message || genericMessage
}

export function normalizeCardYear(year: string): string {
  const trimmedYear = year.trim();

  if (!/^\d{2}$|^\d{4}$/.test(trimmedYear)) {
    throw new Error("Invalid card year format");
  }

  if (trimmedYear.length === 4) return trimmedYear;

  const currentYear = new Date().getFullYear();
  const currentCentury = Math.floor(currentYear / 100) * 100;
  return String(currentCentury + Number(trimmedYear));
}